import React from 'react';

const Footer = () => {
  return (
    <footer className="p-5 bg-gray-900 text-white text-center">
      <p>&copy; 2024 <a href='https://linkedin.com/in/visheshrawal'>Vishesh Rawal</a>. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
